import { schema } from "normalizr";
import { Board } from "./board";

export const Boards = new schema.Array(Board);
